import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import MyRouter from 'routers/index';
import store from 'store';
import DefaultHelmet from 'components/DefaultHelmet/DefaultHelmet';

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

const theme = createTheme({
  palette: {
    primary: {
      main: '#EE2076',
    },
    background: {
      default: '#ffffff',
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="bg-white text-base text-neutral-900 dark:bg-neutral-900 dark:text-neutral-200">
            <DefaultHelmet />
            <ReduxProvider store={store}>
              <MyRouter />
            </ReduxProvider>
          </div>
        </ThemeProvider>
      </GoogleReCaptchaProvider>
    </HelmetProvider>
  );
}

export default App;
